import React from 'react'
import "./Core_benefits.css"
import Common_title from '../../common/common-title/Common_title'
import Core_benefits_card from './core-benefits-card/Core_benefits_card'

function Core_benefits() {
    return (
        <>
            <section className='Core_benefits margin_section'>
                <div className="container">
                    <Common_title headingText="Core " spanText=" Benefits" />
                </div>

                <div className="content_section">
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-3 col-md-4 col-sm-6 order-md-1 order-2">
                                <div className='cards_holder'>
                                    <div>
                                        <Core_benefits_card imgSrc="/assets/images/home/core-benefits/bell.png" text="Smart Rent Reminders" />
                                        <Core_benefits_card imgSrc="/assets/images/home/core-benefits/shield.png" text="Secure, Fast Transactions" />
                                        <Core_benefits_card imgSrc="/assets/images/home/core-benefits/clock.png" text="Payment History & Receipts" />
                                    </div>
                                </div>
                            </div>

                            <div className="col-xl-6 col-md-4 order-md-2 order-1">
                                <div className="mock_up_img_holder">
                                    <img src="/assets/images/home/core-benefits/mobiles.png" alt="mobiles" className='mock_up' />
                                </div>
                            </div>

                            <div className="col-xl-3 col-md-4 col-sm-6 order-md-3 order-3">
                                <div className='cards_holder'>
                                    <div>
                                        <Core_benefits_card imgSrc="/assets/images/home/core-benefits/upload.png" text="Upload Bills & Enter Meter Readings" />
                                        <Core_benefits_card imgSrc="/assets/images/home/core-benefits/home.png" text="Electricity Bill Payments" />
                                        <Core_benefits_card imgSrc="/assets/images/home/core-benefits/users.png" text="Easy Management for Tenants & Households" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section >
        </>
    )
}

export default Core_benefits